<template>
  <div class="searchBox">
    <el-card class="box-card">
      <router-link to="/ChinaEnterprise">
        <i class="el-icon-s-home icon-home"></i>
      </router-link>
      <el-input v-model="data.keywords" class="searchInput"
                placeholder="Please enter enterprise name,or keywords of the article,and separate multiple keywords with spaces."
                prefix-icon="el-icon-search" @keyup.enter.native="doSearch">
      </el-input>
      <el-tabs v-model="activeName" class="tabs" type="border-card" @tab-click="handleClick">
        <el-tab-pane label="Comprehensive" name="0"/>
        <el-tab-pane label="Enterprise" name="1">
          <manuscript-search ref="manuscriptSearch"/>
        </el-tab-pane>
        <el-tab-pane label="Article" name="2">
          <enterprise-search ref="enterpriseSearch"/>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <el-card v-show="activeName !== '2'" class="content">
      <enterprise ref="enterprise"/>
    </el-card>
    <el-card v-show="activeName !== '1'" class="content">
      <manuscript ref="manuscript"/>
    </el-card>
  </div>

</template>
<script>
import Enterprise from '@/views/brand/search/enterprise.vue'
import Manuscript from '@/views/brand/search/manuscript.vue'
import ManuscriptSearch from '@/views/brand/search/manuscriptSearch.vue'
import EnterpriseSearch from '@/views/brand/search/enterpriseSearch.vue'
import request from "@/views/brand/utils/request";

export default {
  name: "search",
  components: {Manuscript, Enterprise, ManuscriptSearch, EnterpriseSearch},
  data() {
    return {
      bool: {articleLoading: false, enterpriseLoading: false},
      result: {enterprise: {totalRecords: 0, pageData: []}, article: {totalRecords: 0, pageData: []}},
      page: {enterprise: {page: 1, size: 10}, article: {page: 1, size: 10}},
      data: {
        keywords: '',
        enterprise: {keywords: '', region: '', industries: []},
        article: {name: [''], industries: [], companies: [], mediaCountries: [], pubTime: []}
      },
      paramForm: {
        enterprise: {
          region: ['Anhui', 'Beijing', 'Chongqing', 'Fujian', 'Gansu', 'Guangdong', 'Guangxi', 'Guizhou', 'Hainan',
            'Hebei', 'Heilongjiang', 'Henan', 'Hong Kong', 'Hubei', 'Hunan', 'Inner Mongoria', 'Jiangsu', 'Jiangxi',
            'Jilin', 'Liaoning', 'Macao', 'Ningxia', 'Qinghai', 'Shaanxi', 'Shandong', 'Shanghai', 'Shanxi', 'Sichuan',
            'Taiwan', 'Tianjing', 'Tibet', 'Xinjiang', 'Yunnan', 'Zhejiang'],
          industries: []
        },
        article: {industries: [], countries: []}
      },

    }
  },
  created() {
    var showTab = this.$route.query.showTab
    if (showTab) {
      this.activeName = showTab
    }
    var industry = this.$route.query.industry
    if (industry) {
      this.data.article.industries.push(industry)
    }

  },
  mounted() {
    var keywords = this.$route.query.keywords
    if (keywords) {
      this.data.keywords = keywords
    }
    if (this.$route.query.from != null) {
      request({method: 'get', url: '/api/client/chinaEnterprise/getUserConfigParam'}).then(result => {
        if (result.data != null) {
          if (result.data.industries != null && result.data.industries.length > 0) {
            this.data.enterprise.industries = result.data.industries
          }
          if (result.data.industries != null && result.data.industries.length > 0) {
            this.data.article.industries = result.data.industries
          }
          if (result.data.companies != null && result.data.companies.length > 0) {
            this.data.article.companies = result.data.companies
            const data = this.data.article.companies
            request({data, method: 'post', url: '/api/client/search/doFocus'}).then(result => {
            })
          }
          if (result.data.mediaCountries != null && result.data.mediaCountries.length > 0) {
            this.data.article.mediaCountries = result.data.mediaCountries
          }
          if (result.data.pubTime != null && result.data.pubTime.length > 0) {
            this.data.article.pubTime = result.data.pubTime
          }
          this.param.userConfig = result.data
        }
      })
    } else {
      this.doSearch()
    }
    this.getHotValue()
  },
  watch: {
    'data.article': {
      handler () {
        this.page.article.page = 1
        this.getArticleList()
      },
      deep: true
    },
    'data.enterprise': {
      handler () {
        this.page.enterprise.page = 1
        this.getCompanyList()
      },
      deep: true
    }
  },
  computed: {
    activeName: {
      get() {
        return this.$store.state.brandMoudle.activeName;
      },
      set(n) {
        this.$store.commit('setActiveName', n);
      }
    }
  },
  methods: {
    getHotValue() {
      var params = {column: 'INDUSTRY_TAGS', topNum: 1000}
      request({params, method: 'get', url: '/api/client/columnHotValue'}).then(result => {
        this.paramForm.enterprise.industries = result.data
        this.paramForm.article.industries = result.data
      })
      params = {column: 'MEDIA_COUNTRY', topNum: 1000}
      request({params, method: 'get', url: '/api/client/columnHotValue'}).then(result => {
        this.paramForm.article.countries = result.data
      })
    },
    doSearch() {
      this.page.enterprise.page = 1
      this.page.article.page = 1
      this.getCompanyList()
      this.getArticleList()
    },
    handleClick(tab) {
      this.$store.commit('setActiveName', tab.index);
    },
    getCompanyList() {
      const params = JSON.parse(JSON.stringify(this.page.enterprise))
      const data = JSON.parse(JSON.stringify(this.data.enterprise))
      data.keywords = this.data.keywords
      this.bool.enterpriseLoading = true
      request({data, params, method: 'post', url: '/api/client/search/enterprise'}).then(result => {
        if (result.data.rows) {
          result.data.pageData = result.data.rows
          result.data.totalRecords = result.data.total
        }
        this.bool.enterpriseLoading = false
        this.result.enterprise = result.data
      }).catch(result => {
        this.result.enterprise = {totalRecords: 0, pageData: []}
        this.bool.enterpriseLoading = false
      })
    },
    getArticleList() {
      var totalSize = this.page.article.page * this.page.article.size
      if(totalSize > 10000){
        this.$message.warning("Only 10,000 pieces of data are returned for now")
        return
      }

      const params = JSON.parse(JSON.stringify(this.page.article))
      const data = JSON.parse(JSON.stringify(this.data.article))
      data.name[0] = this.data.keywords
      this.bool.articleLoading = true
      request({data, params, method: 'post', url: '/api/client/search/article'}).then(result => {
        if (result.data.rows) {
          result.data.pageData = result.data.rows
          result.data.totalRecords = result.data.total
        }
        this.bool.articleLoading = false
        for (let i = 0; i < result.data.pageData.length; i++) {
          if (result.data.pageData[i].positiveTags != null) {
            result.data.pageData[i].positiveTags = result.data.pageData[i].positiveTags.split(';')
          } else {
            result.data.pageData[i].positiveTags = []
          }
          if (result.data.pageData[i].negativeTags != null) {
            result.data.pageData[i].negativeTags = result.data.pageData[i].negativeTags.split(';')
          } else {
            result.data.pageData[i].negativeTags = []
          }
          if (result.data.pageData[i].industryTags != null) {
            result.data.pageData[i].industryTags = result.data.pageData[i].industryTags.split(';')
          } else {
            result.data.pageData[i].industryTags = []
          }
          if (result.data.pageData[i].mediaCountry != null) {
            result.data.pageData[i].mediaCountry = result.data.pageData[i].mediaCountry.split(';')
          } else {
            result.data.pageData[i].mediaCountry = []
          }
          if (result.data.pageData[i].companyTags != null) {
            result.data.pageData[i].companyTags = result.data.pageData[i].companyTags.split(';')
          } else {
            result.data.pageData[i].companyTags = []
          }
          result.data.pageData[i].pubTime = new Date(result.data.pageData[i].pubTime).toDateString()
        }
        this.result.article = result.data
      }).catch(result => {
        this.result.article = {totalRecords: 0, pageData: []}
        this.bool.articleLoading = false
      })
    }
  }
}
</script>

<style scoped>
.searchBox {
  height: 1450px;
}

.searchBox .icon-home {
  color: #2f8eff;
  font-size: 50px;
  text-shadow: 0 0 4px #666666;
  vertical-align: middle;
  float: left;
  margin-left: 1.5%;
}

.searchBox .tabs {
  margin-top: 20px;
}

.searchBox .content {
  margin-top: 20px;
}

#app .box-card ::v-deep .el-card__body, .el-main {
  padding: 25px 25px;
}

.searchBox ::v-deep .el-input.searchInput .el-input__inner {
  padding-left: 50px;
}

.searchBox ::v-deep .searchInput.el-input .el-input__prefix .el-input__icon {
  font-size: 20px;
  font-weight: bolder;
  padding-left: 10px;
}

.searchInput .el-input__icon {
  font-size: 25px;
  margin-left: 10px;
  font-weight: bolder;
}

.header .title {
  float: left;
  height: 50px;
  line-height: 50px;
  border-left: 12px solid #2f8eff;
  font-size: 18px;
  font-weight: bold;
  padding-left: 8px;
}

.header .amount {
  float: right;
  line-height: 50px;
  font-size: 14px;
  cursor: pointer;
}

.clearBoth:after {
  content: '';
  display: block;
  clear: both;
}

.searchBox /deep/ .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
  border-right-color: #fff;
  border-left-color: #fff;
}

</style>
